import { render, staticRenderFns } from "./DevToolsPanel.vue?vue&type=template&id=2975cb80&scoped=true&"
import script from "./DevToolsPanel.vue?vue&type=script&lang=js&"
export * from "./DevToolsPanel.vue?vue&type=script&lang=js&"
import style0 from "./DevToolsPanel.vue?vue&type=style&index=0&id=2975cb80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2975cb80",
  null
  
)

export default component.exports